// BUCKET_CDN URL
const bucketImgCdnURL = "https://static.trackier.io/csnext/images";
const bucketFileCdnURL = "https://static.trackier.io/files";

const baseURL = import.meta.env.VITE_APP_PANEL_API_BASE_URL;
const superAdminURL = import.meta.env.VITE_APP_PANEL_API_BASE_URL;

//Template config options
const themeConfig = {
    app: {
        name        : "CSNook",
        darkLogo    : "logo/logo-dark-2.png",
        logo        : "logo/logo-2.png",
        primaryColor: "#013b40"
    },
    layout: {
        customizer: false,
        showOffset: 300
    },
    apiUrl: {
        base      : baseURL,
        superAdmin: superAdminURL
    },
    bucketImgCdnURL,
    bucketFileCdnURL,
    helpDeskURL: "https://help.csnext.com/en/"
};

export default themeConfig;
